const useCookies = () => {
  const setCookie = (name: string, value: string, params?: string) => {
    document.cookie = `${name}=${value};${params ?? ''};Path=/`;
  };

  return { setCookie };
};

export default useCookies;
